// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"4f34b760","614":"400c4613","673":"ccb9ac4d","994":"7dd6f035"}[chunkId] + ".chunk.js";
};